
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appInfo, appInstance } from 'src/api';
import { message } from 'antd';

class ModulesAction extends ActionBasic<ModulesState> {


    public init = async () => {
        await this.getAppCategory();
        this.modulesState.searchInfo.appCategoryId = this.modulesState.appCategoryList[0].categoryId;
        this.getAppList();
    }
    /** 
     * 获取app列表(判断类型 请求不同接口)
     */
    public getAppList = async () => {
        const type = this.modulesState.searchInfo.isOpen;
        //设置列表容器的滚动条回到顶部
        this.modulesState.carouselboxContent ? this.modulesState.carouselboxContent.scrollTop = 0 : null;
        this.clearChecked();
        if (type === 'myApp') {
            this.getCompanyQuery();
        } else {
            this.getAppListData();
        }
    }
    // 清楚当前选择列表情况
    clearChecked = () => {
        this.modulesState.isCheckedAll = false;
        this.modulesState.checkedAppList.clear();
        this.modulesState.isCheckcedAgreeAll = false;
        this.modulesState.checkcedAgreeList.clear();
        this.setModulesState();
    }
    /** 
     * 获取app列表 共有应用以及私有应用 无分页
     */
    public getAppListData = async () => {
        const { appCategoryId, isOpen } = this.modulesState.searchInfo;
        const param = {
            isOpen: isOpen === '0' || isOpen === '1' ? isOpen : undefined,
            appCategoryId: appCategoryId !== 0 ? appCategoryId : undefined,
        };
        const appData = await appInfo.appInfoQueryNoPage(this, param);
        if (!appData.er) {
            this.modulesState.appList = appData.res as any;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 获取app列表 我的应用
     */
    public getCompanyQuery = async () => {
        // const isOpen = this.modulesState.isOpen;
        const param = {
            appCategoryId: this.modulesState.searchInfo.appCategoryId === 0 ? undefined : this.modulesState.searchInfo.appCategoryId,
        };
        const appData = await appInstance.companyQueryNoPage(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res as any;
            this.setModulesState(this.modulesState);
        }
    }

    /** 获取app类型列表 */
    public getAppCategory = async () => {
        const appData = await appInstance.appCategory(this, {});
        if (!appData.er) {
            this.modulesState.appCategoryList = appData.res.list;
            this.setModulesState(this.modulesState);

        }
    }
    /**
     * app批量操作
     */
    public appBacthHandle = async () => {
        if (this.modulesState.checkedAppList.size === 0) {
            message.info('请您选择需要激活的App');
            return;
        }
        this.modulesState.activTipsM = true;
        this.setModulesState();
    }
    /**
     *
     * 判断当前协议是否已经全部勾选，如果已勾选，更新是否全部勾选协议状态isCheckcedAgreeAll
     * @memberof ModulesAction
     */
    public isCheckcedAgreeAllHandle = () => {
        this.modulesState.isCheckcedAgreeAll = [...this.modulesState.checkedAppList].every(appId => [...this.modulesState.checkcedAgreeList].indexOf(appId) !== -1);
        this.setModulesState();
    }
    public isAppCheckedAll = () => {
        this.modulesState.isCheckedAll = this.modulesState.appList.filter(value => !value.isActivated)
            .every(item => this.modulesState.checkedAppList.has(item.appId));
        this.setModulesState();
    }
    /**
     * 采集需要的checkedAppList
     * @param e 
     * @param value 
     */
    public appCheckedListHandle = (e: any, value: any) => {
        const flag = this.modulesState.checkedAppList.has(value.appId);
        if (flag) {
            this.modulesState.checkedAppList.delete(value.appId);
        } else {
            this.modulesState.checkedAppList.add(value.appId);
        }
        this.setModulesState();
        this.isAppCheckedAll();
    }
    /**
     * 选择协议方法，记录已勾选的协议列表
     *
     * @param {*} e
     * @param {*} value
     * @memberof ModulesAction
     */
    public checkcedAgreeListHandle = (e: any, value: any) => {
        const flag = this.modulesState.checkcedAgreeList.has(value.appId);
        if (flag) {
            this.modulesState.checkcedAgreeList.delete(value.appId);
        } else {
            this.modulesState.checkcedAgreeList.add(value.appId);
        }
        this.isCheckcedAgreeAllHandle();
        this.setModulesState();
    }
    /**
     * 全选当前协议列表
     */
    public checkcedAgreeAll = () => {
        if (!this.modulesState.isCheckcedAgreeAll) { // 当前为未全选
            this.getCheckedAppInfo().forEach((item) => {
                const flag = this.modulesState.checkcedAgreeList.has(item.appId);
                if (!flag) {
                    this.modulesState.checkcedAgreeList.add(item.appId);
                }
            });
        } else {
            this.modulesState.checkcedAgreeList.clear();
        }
        this.modulesState.isCheckcedAgreeAll = !this.modulesState.isCheckcedAgreeAll;
        this.setModulesState();
    }
    // app列表全选
    public checkedAll = () => {
        if (!this.modulesState.isCheckedAll) { // 当前为未全选
            this.modulesState.appList.forEach((item) => {
                const flag = this.modulesState.checkedAppList.has(item.appId);
                if (!flag && (!item.isActivated)) {
                    this.modulesState.checkedAppList.add(item.appId);
                }
            });
        } else {
            this.modulesState.checkedAppList.clear();
        }
        this.modulesState.isCheckedAll = !this.modulesState.isCheckedAll;
        this.setModulesState();
    }
    /**
     *  批量激活应用
     */
    public appInstanceActivate = async () => {
        const result = await appInstance.appMultiActivare(this, { appIdList: [...this.modulesState.checkedAppList] });
        if (result.er) { return; }
        
        this.clearChecked();
        this.modulesState.activTipsM = false;
       
        message.success('激活成功!');
        this.modulesState.checkedAppList.clear();
        this.modulesState.checkcedAgreeList.clear();
        this.modulesState.isReadCheckd = false;
        this.setModulesState();
        // this.activeTipsM(false);
        this.getAppList();

    }
    /**
     * 根据选择的appId获取app信息列表 
     * @param 
     */
    public getCheckedAppInfo = () => {
        const checkedAppIds = [...this.modulesState.checkedAppList];
        return this.modulesState.appList.filter(item => checkedAppIds.indexOf(item.appId) !== -1);
    }
    /** 激活弹框提示 */
    public activeTipsM = (isOpen: boolean) => {
        this.modulesState.activTipsM = isOpen;
        this.modulesState.isReadCheckd = false;
        this.modulesState.isCheckcedAgreeAll = false;
        this.modulesState.checkcedAgreeList.clear();
        this.setModulesState();
    }
    /** 监听 激活提示框 check按钮 */
    public onChangeCheck = (e) => {
        this.modulesState.isReadCheckd = e.target.checked;
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchActivated/Modules.Action.ts